// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","name":"Footer_name__f3GY6","link":"Footer_link__3Ie8d","icons":"Footer_icons__QDrf7"};